import { JobReportComponent } from '../job-report/job-report.component';
import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { SocialmediaDialogComponent } from '../socialmedia-dialog/socialmedia-dialog.component';
import { ConfirmDeleteDialogComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';
import { PromoteJobsOfferDialogComponent } from '../promote-jobs-offer-dialog/promote-jobs-offer-dialog.component';
import { SendMessageComponent } from '../send-message/send-message.component';
import { Router, ActivatedRoute } from '@angular/router';
import { JobOffersService } from '../../services/job-offers.service';
import { JobsOffer } from '../../models/jobs-offer';
import { VenueService } from '../../services/venue.service';
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';
import { InviteComponent } from '../invite/invite.component';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { PaymentDialogComponent } from '../payment-dialog/payment-dialog.component';
import { EditOfferVacancyDialogComponent } from '../edit-offer-vacancy-dialog/edit-offer-vacancy-dialog.component';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
  selector: 'app-list-offer',
  templateUrl: './list-offer.component.html',
  styleUrls: ['./list-offer.component.css']
})
export class ListOfferComponent implements OnInit {

  errorMessage: string;
  viewActive: boolean = false;
  selectedOption: string;
  venues: Observable<any[]>;
  selectedUsers = 0;
  jobie: any;

  venue_id:string;
  offer_id:string;

  premiumView: boolean;
  premiumJob: number;

  jobs: Observable<JobsOffer[]>;
  jobsPro: Observable<JobsOffer[]>;
  loading: boolean;
  loading2: boolean;
  max: number = 5;
  page: number = 1;
  total: number = 0;
  role: string;

  private landing = `${ environment.landing }`;

  constructor(
      private _router: Router,
      public dialog: MdDialog,
      private jobService: JobOffersService,
      private venueService: VenueService,
      private route: ActivatedRoute,
      private configurationService: ConfigurationService
    ) {
      }

  ngOnInit() {
    if (this.route.snapshot.url[0].path === 'listofferpremium')  {
      this.premiumView = true;
    } else {
      this.premiumView = false;
    }

    this.searchOffers();
    // this.getVenues();

    this.refreshConfiguration();
    this.configurationService.configuration$.subscribe(
      response => {
        if (response) {
          this.refreshConfiguration();
        } else {
          this.role = '';
        }
        // this.dialog.open(MessageBoxDialog, {data: {message: "No se pudo conectar con el servidor, Problemas de conexión con internet", success:true, showIcon:true}});
      }
    );
  }

  refreshConfiguration() {
    if (localStorage.getItem('role')) {
      this.role = localStorage.getItem('role');
    } else {
      this.role = '';
    }
  }

  gotoLanding (job) {
    if (job.status !== -4)
    {
      window.open(this.landing + job.id, '_blank');
    }
  }

  // getVenues() {
  //   this.venues = this.venueService.getVenues()
  //   // FIXME: remove duplicates and items without ID (shouldn't be needed)
  //     .map(res => res.filter(item => item.id && item.name));
  // }

  getVenueId($event){
    this.venue_id = $event;
  }


  changePremium() {
    if (this.premiumView) {
      this.premiumView = false;
    } else {
      this.premiumView = true;
    }
  }
  getOfferInput($event){
    this.offer_id = $event;
  }
  isSelectedUsers(event){
    if (event <= 0){
      return true;
    }
    return false;
  }
  openDialogJobReport(job, type) {
    this.jobService.getOffersById(job.id).subscribe(
      data => {
        this.jobie = data;
        this.selectedUsers = this.jobie.users_selected;
        let dialogRef = this.dialog.open(JobReportComponent, {
            data: {
              job: this.jobie,
              create: type,
            }
        });
      dialogRef.afterClosed().subscribe(result => {
        if (result != "YES") {
        }
      });
      },
      error => {
        this.errorMessage = <any>error;
      }
    );

  }

  searchOffers(page?: number, query?: string, venue?: string, active?: boolean, inactive?: boolean, expired?:boolean, deleted?: boolean, archived?:boolean, myOffer?:boolean) {
      this.loading = true;
      this.loading2 = true;
      let status = [];

      if(page == null) {
        page = 1;
      }

      if (active) {
          status.push('1');
      }
      if (inactive) {
        status.push('-1');
        status.push('-2');
      }
      if (expired) {
          status.push('-3');
      }
      if (deleted) {
        status.push('-6');
      }
      if (archived) {
        status.push('-4');
      }

      if (this.premiumView) {
        this.premiumJob = 1;
      } else {
        this.premiumJob = 0;
      }
      if (venue){

      }

      if(query !== undefined){
        let queryArray = query.split(" - ");
        query = queryArray[0];
      }


      this.jobs = this.jobService.getOffers(query, venue, status, page, this.max, this.premiumJob, undefined, undefined, undefined, myOffer, 1)
      .do(res => {
          this.page = page;
          this.total = res.pagination.total;
          this.loading = false;
        }
      ).map(res => res.jobs);
      this.jobsPro = this.jobService.getOffers(query, venue, status, page, this.max, this.premiumJob, undefined, undefined, undefined, myOffer, 2)
      .do(res2 => {
          this.page = page;
          this.total = res2.pagination.total;
          this.loading2 = false;
        }
      ).map(res2 => res2.jobs);
  }

  openDialogDelete(job,status) {
      let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.componentInstance.deleteOffer=true;
      dialogRef.componentInstance.OfferID=job.id;
      dialogRef.componentInstance.OfferStatus=status;
      dialogRef.afterClosed().subscribe(result => {
        if (result != "NO")
          job.status = -6;
      });
  }

  putOffersStatus(job, status) {
    this.jobService.putOffersStatus(job.id, status)
      .subscribe(
        data => {},
        error => this.errorMessage = <any>error
      );
  }

  cloneJob(jobId) {
    // this._router.navigate(['/createoffer', jobId]);
    window.open('/pages/createoffer/' + jobId, '_blank');
  }

  viewJob(jobId) {
    this._router.navigate(['/pages/viewoffer', jobId]);
  }

  viewJobKanban(jobId) {
    this._router.navigate(['/pages/viewjob', jobId]);
  }

  //noinspection JSMethodCanBeStatic
  remapJob(job) {
    job.status = 1;
    job.venue = job.venue.country.name;
  }

  openDialogSocialMedia() {
    let dialogRef = this.dialog.open(SocialmediaDialogComponent);
  }

  openDialogPromoteJobsOffer() {
    let dialogRef = this.dialog.open(PromoteJobsOfferDialogComponent);
  }

  openDialogEdit(id) {
    this._router.navigate(['/pages/createoffer', id]);
  }

  openDialogMessage(name) {
    //todo send job
    let dialogRef = this.dialog.open(SendMessageComponent, {data: {
      nameComponent: 'offer',
      nameOffer: name
    }});

    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
    });
  }

  openDialogInvite(job) {
    if (job.status !== -4)
    {
      let dialogRef = this.dialog.open(InviteComponent);
      dialogRef.componentInstance.createInvite=true;
      dialogRef.componentInstance.Job=job;
      dialogRef.componentInstance.nameComponent='Invitación';
      dialogRef.afterClosed().subscribe(result => {});
    }
  }

  viewIvite(id) {
    this._router.navigate(['/pages/viewinvite'+id]);
  }
  viewForm() {
    this._router.navigate(['/pages/form']);
  }
  viewVenue() {
    this._router.navigate(['/pages/venue']);
  }

  gotoReport(job) {
    if (job.status !== -4) {
      // this._router.navigate(['/reports', job.id]);
      window.open('/pages/reports/' + job.id, '_blank');
    }
  }

  checkReport(event){
    if (event != null){
      return false;
    }else{
      return true;
    }
  }

  gotoCalendar(job) {
    if (job.status !== -4) {
      // this._router.navigate(['/viewevent', job.id]);
      window.open('/pages/viewevent/' + job.id, '_blank');
    }
  }

  gotoKanban(job) {
    if (job.status !== -4) {
      this._router.navigate(['/pages/viewinvite', job.id]);
    }
  }



  gotoKanbanBlank(job) {
    if (job.status !== -4) {
      // this._router.navigate(['/viewinvite', job.id]);
      window.open('/pages/viewinvite/' + job.id, '_blank');
    }
  }

  openDialogPaymentCredits() {
    let dialogRef = this.dialog.open(PaymentDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      this.searchOffers();
    });
  }

  openDialogEditOfferVacancy(job) {
    if (job.status !== -4) {
      let dialogRef = this.dialog.open(EditOfferVacancyDialogComponent);
      dialogRef.componentInstance.jobsOffer = job;
      dialogRef.afterClosed().subscribe(result => {
        this.searchOffers();
      });
    }
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'En este tipo de ofertas puedes generar formularios de entrevistas para que sean realizadas por nuestros robots inteligentes. También podrán solicitar documentos que podrán ser requeridos desde la plataforma.', information: true, showIcon: true}});
  }

  showInformationNoPremium() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'En este tipo de ofertas no puedes generar formularios de entrevistas para que sean realizadas por nuestros robots inteligentes. También podrán solicitar documentos que podrán ser requeridos desde la plataforma.', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/list-offer/list-offer.component.ts